import { useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import api from "../../api/axios";

export default function DeleteTestUser({ user, onDeleted }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (user.role !== "user" || user.business_name) return null;
  const remove = async event => {
    event.preventDefault();
    if (busy || email.trim().toLowerCase() !== user.email.toLowerCase()) return;
    setBusy(true); setError("");
    try {
      await api.delete("/admin/users/" + user.id, { data: { confirmEmail: email.trim() } });
      setOpen(false);
      onDeleted();
    } catch (failure) { setError(failure.response?.data?.error || "No se pudo eliminar. Intenta de nuevo."); }
    finally { setBusy(false); }
  };
  return <>
    <Button size="sm" variant="outline-danger" className="d-block ms-auto mt-2" onClick={() => { setError(""); setEmail(""); setOpen(true); }}><i className="bi bi-trash me-1" />Eliminar cuenta de prueba</Button>
    <Modal show={open} onHide={() => !busy && setOpen(false)} centered>
      <Modal.Header closeButton={!busy}><Modal.Title>Eliminar cuenta</Modal.Title></Modal.Header>
      <Form onSubmit={remove}>
        <Modal.Body>
          <p>Se eliminaran los datos de <strong>{user.display_name}</strong>: {user.binder_count} binders, {user.card_count} cartas y {user.post_count} publicaciones. No se puede deshacer.</p>
          <p>Si tiene intercambios o juntadas, el borrado se bloqueara. Las fotos almacenadas no se purgan automaticamente.</p>
          {error && <Alert variant="danger" role="alert">{error}</Alert>}
          <Form.Group controlId={"delete-confirm-" + user.id}><Form.Label>Escribe {user.email} para confirmar</Form.Label><Form.Control type="email" value={email} disabled={busy} onChange={event => setEmail(event.target.value)} autoComplete="off" required /></Form.Group>
        </Modal.Body>
        <Modal.Footer><Button variant="outline-secondary" disabled={busy} onClick={() => setOpen(false)}>Cancelar</Button><Button variant="danger" type="submit" disabled={busy || email.trim().toLowerCase() !== user.email.toLowerCase()}>{busy ? <Spinner animation="border" size="sm" /> : "Eliminar definitivamente"}</Button></Modal.Footer>
      </Form>
    </Modal>
  </>;
}
